import { render } from "./BannerList.vue?vue&type=template&id=ba652550&scoped=true"
import script from "./BannerList.vue?vue&type=script&lang=js"
export * from "./BannerList.vue?vue&type=script&lang=js"

import "./BannerList.vue?vue&type=style&index=0&id=ba652550&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-学校主页/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba652550"]])

export default __exports__